<template>
  <tr>
    <th v-for="(col, key, index) in cols" :key="index" v-show="($_.isUndefined(col.hidden) || col.hidden == false) && (hiddenCols.indexOf(key) == -1 || col.default)" :class="`column column-${key}`">
      <component v-if="key != 'cb'" :is="colHead(key)" :config="configHead(cols, key, 'head')" @refreshTable="$emitter.emit('TableList.Refresh')"></component>
      <component v-else :is="config.components.ColHeadCb" :config="{ cb }" @checkBoxAllClicked="checkBoxAllClicked" />
    </th>
  </tr>
</template>

<script>
export default {
  computed: {
    store() {
      return this.config?.store
    },
    storeId() {
      return this.config?.storeId
    },
    cols() {
      return this.config?.cols || {}
    },
    rows() {
      return this.config?.rows || {}
    },
    cb() {
      return this.config?.cb || {}
    },
    screenOptions() {
      return this.config?.screenOptions || {}
    },
    hiddenCols() {
      return this.screenOptions.hidden_cols || []
    }
  },
  methods: {
    configHead(cols, key, position) {
      return {
        cols,
        key,
        position,
        store: this.store
      }
    },
    colHead(name) {
      return this.config?.components[`ColHead${_.pascalCase(name)}`] || this.config?.components.ColHeadDefault
    },
    checkBoxAllClicked(e) {
      Object.entries(this.rows).forEach(([rowIndex]) => {
        this.store.commit(`rows.${rowIndex}.cb`, e)
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
